const ThemeToken = {
  colorPrimary: "#008363",
  colorPrimaryActive: "#F1416C",
  colorBgTextActive: "#F1416C",
  colorLink: "#008363",
  colorLinkHover: "#178f6d",
  borderRadius: 4,
  Radio: {
    borderRadius: 2,
  },
};

export const proLayoutSettings = {
  title: "",
  siderWidth: 252,
  iconfontUrl: "/iconfont.js",
};

export const proLayoutLogo = {
  collapsed:
    "https://img06.weeecdn.com/cs/image/898/337/E76C460A6E290CE_0x0.webp",
  expanded:
    "https://img06.weeecdn.com/cs/image/566/366/7E6538229482E7E9_0x0.webp",
};

export default ThemeToken;
